import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";
import { OrganizationListItem } from "../model/OrganizationListSuccessResponse";

export const LIST_ORGANIZATIONS_SUCCESS =
  "ORGANIZATION:LIST_ORGANIZATIONS_SUCCESS";

export interface ListOrganizationsSuccessAction extends Action {
  type: typeof LIST_ORGANIZATIONS_SUCCESS;
  organization: OrganizationKeyName;
  data: OrganizationListItem[];
}

export const listOrganizationsSuccessAction = (
  organization: OrganizationKeyName,
  data: OrganizationListItem[]
): ListOrganizationsSuccessAction => ({
  type: LIST_ORGANIZATIONS_SUCCESS,
  organization,
  data,
});
